<template>
	<div class="enter registration cover">
		<!-- Outer -->
		<div class="enter__outer">

			<!-- Enter Inner -->
			<div class="enter__inner registration__enter-inner">
				<div class="main-logo registration__logo">
					<img class="main-logo__item" src="../../../assets/img/logo.png" alt="logo">
				</div>
			</div>
			<!-- Enter Inner End -->

			<!-- Enter Inner -->
			<div class="enter__inner">
				<form id="entry_form" class="enter-form registration__form" @submit.prevent="sendCode">
					<p class="enter__text">На номер +{{phone}} отправлено sms с кодом</p>
					<input class="enter-text-field" type="text" placeholder="Введите 6-ти значный код" v-model="secretCode">
					<input class="enter-form__button" type="submit" value="Продолжить">
					<a class="enter-form__link" @click="resendNumber">Код не пришел!</a>
					<p class="enter__text">Шаг 2 из 4</p>
				</form>
				
			</div>
			<!-- Enter Inner End -->

		</div>
		<!-- Outer End -->

	</div>
</template>

<script>
	export default {
		name: "SecondStep",
		computed: {
			phone() {
				return this.$storage.get('reg.phone')
			}
		},
		data() {
			return {
				secretCode: ''
			}
		},
		methods: {
			sendCode() {
				if(!this.secretCode)
					return false

				this.$api.post('auth/sms/check-code', {
					phone: this.phone,
					code: this.secretCode,
					_scenario: 'registration'
				}).then(() => {
					this.$storage.set('reg.code', this.secretCode)
					this.$router.push({name: 'Three'})
				})
			},
			resendNumber() {
				this.$api.post('register-prepare', {
					phone: this.phone
				}).then(() => {
					this.$event.toast('s', 'На Ваш номер ' + this.phone + ' было отправлено сообщение с кодом подтверждения')
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// Two.vue?52637386